import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import clsx from 'clsx';
import Input from '@material-ui/core/Input';

export type PaginationControlProps = {
    page: number;
    canPreviousPage: boolean;
    canNextPage: boolean;
    onPrevious: () => void;
    onNext: () => void;
    onGotoPage: (index: number) => void;
    pageCount: number;
};

const useStyles = makeStyles((theme) => ({
    control: {
        margin: theme.spacing(0, 1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: theme.spacing(10),
        height: theme.spacing(4),
        // border: `${theme.spacing(1 / 8)} solid ${theme.custom.palette.placeholder}`,
        borderRadius: theme.spacing(0.5),
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: theme.spacing(4),
        width: theme.spacing(4),
        cursor: 'pointer',
        border: 0,
        backgroundColor: 'transparent',
    },
    iconWrapperDisabled: {
        cursor: 'default',
    },
    icon: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        // color: theme.custom.palette.data,
    },
    iconDisabled: {
        // color: theme.custom.palette.placeholder,
    },
    numberField: {
        flexGrow: 1,
        '&:before, &:after': {
            display: 'none',
        },
    },
    numberInput: {
        textAlign: 'center',
        // fontSize: theme.custom.typography.base.fontSize['14'],
        // color: theme.custom.palette.data,
        // fontWeight: theme.custom.typography.base.fontWeight.bold,
        // letterSpacing: theme.custom.typography.base.letterSpacing.medium,
        // fontFamily: theme.custom.typography.base.fontFamily,
    },
}));

const PaginationControl: React.FC<PaginationControlProps> = ({
    page,
    onPrevious,
    onNext,
    canPreviousPage,
    canNextPage,
    onGotoPage,
    pageCount,
}) => {
    const classes = useStyles();

    const [inputPageValue, setInputPageValue] = useState<string>(
        page.toString()
    );
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
    const TIMER_DELAY = 750;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const regExp = /^[1-9][0-9]*$/;
        const newValue = event.target.value;
        if (newValue === '' || regExp.test(newValue)) {
            setInputPageValue(newValue);
            const pageIndex = parseInt(newValue, 10);
            if (timer) {
                clearTimeout(timer);
            }
            setTimer(
                setTimeout(() => {
                    if (
                        Number.isInteger(pageIndex) &&
                        pageIndex >= 0 &&
                        pageIndex <= pageCount
                    ) {
                        onGotoPage(pageIndex);
                    } else {
                        setInputPageValue(page.toString());
                    }
                }, TIMER_DELAY)
            );
        }
    };

    React.useEffect(() => {
        setInputPageValue(page.toString());
    }, [page]);

    return (
        <div className={classes.control}>
            <button
                className={clsx(
                    classes.iconWrapper,
                    !canPreviousPage && classes.iconWrapperDisabled
                )}
                onClick={onPrevious}
                type="button"
                disabled={!canPreviousPage}
            >
                <ArrowLeftIcon
                    className={clsx(
                        classes.icon,
                        !canPreviousPage && classes.iconDisabled
                    )}
                />
            </button>
            <Input
                className={classes.numberField}
                value={inputPageValue}
                onChange={handleChange}
                classes={{ input: classes.numberInput }}
            />
            <button
                className={clsx(
                    classes.iconWrapper,
                    !canNextPage && classes.iconWrapperDisabled
                )}
                onClick={onNext}
                type="button"
                disabled={!canNextPage}
            >
                <ArrowRightIcon
                    className={clsx(
                        classes.icon,
                        !canNextPage && classes.iconDisabled
                    )}
                />
            </button>
        </div>
    );
};

export default PaginationControl;
